export default __webpack_public_path__ + "static/9-2718b677aa9800c91c97096511faee3d.png";